const actions = {
  setColorTheme(context, payload) {
    context.commit("mutationTheme", payload);
  },

  setLogo(context, payload) {
    context.commit("mutationLogo", payload);
  },

  setSidebarMenuDefault(context, payload) {
    context.commit("mutationSidebarMenuDefault", payload);
  },

  setSidebarMenu(context, payload) {
    context.commit("mutationSidebarMenu", payload);
  },

  setHeaderPolicies(context, payload) {
    context.commit("mutationHeaderPolicies", payload);
  },

  setHeaderClaims(context, payload) {
    context.commit("mutationHeaderClaims", payload);
  },

  setPreviousAccount(context, payload) {
    context.commit("mutationPreviousAccount", payload);
  },

  setLocale(context, payload) {
    context.commit("mutationLocale", payload);
  },

  setHeaderTableColumn(context, payload) {
    context.commit("mutationHeaderTableColumn", payload);
  },

  destroyStates(context) {
    context.commit("mutationHeaderPolicies", "");
    context.commit("mutationSidebarMenuDefault", "");
    context.commit("mutationSidebarMenu", "");
    context.commit("mutationHeaderClaims", "");
    context.commit("mutationPreviousAccount", "");
    context.commit("mutationHeaderTableColumn", "");
    context.commit("mutationPlatformConfigFilter", {});
    context.commit("mutationInternalToolsFilter", {});
    context.dispatch("organization/destroyStates", null, { root: true });

    //rule engine filter
    if (localStorage.getItem("ruleEngineFilter")) {
      localStorage.removeItem("ruleEngineFilter");
    }
  },
};

export default actions;
